<!-- 等待页面 -->
<template>
  <div class="apply-waiting">
    <p>
      You have successfully signed the contract and finished the application process! Our staff will contact you about next steps after your role has been activate.
    </p>
  </div>
</template>

<script>
// api
import { applyMentorStepsSM, applyMentorStepsEM } from '@/api/apply'
export default {
  name: 'apply-waiting',
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  created () {
    this.isWaiting()
  },
  methods: {
    // 判断等待或跳转的逻辑
    isWaiting () {
      if (this.$route.params.type === 'EM-waintg') {
        applyMentorStepsEM().then(res => {
          let result = res.data.result
          if (result.status === 'HAS_SIGN') {
            this.jumpPage()
          }
        })
      } else if (this.$route.params.type === 'SMCM-waintg') {
        applyMentorStepsSM({}).then(res => {
          let result = res.data.result
          if (result.status === 'HAS_SIGN') {
            this.jumpPage()
          }
        })
      }
    },
    jumpPage () {
      this.$router.push({
        name: 'apply-select'
      })
    }
  }
}
</script>
<style lang='less' scoped>
.apply-waiting {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #323232;
  padding: 20px 0;
  p {
    width: 1280px;
    line-height: 40px;
    font-size: 20px;
    color: #ffffff;
    margin: 0 auto;
  }
}
</style>
